import { decodeAuthToken } from '@/service/decode-auth-token';
import { AuthStore } from '@/types/stores/auth';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      token: null,
      context: null,
      persist: true,
      isRefreshing: true,
      login: (token: string) =>
        set({ isAuthenticated: true, token, context: decodeAuthToken(token), isRefreshing: false }),
      logout: () => set({ isAuthenticated: false, token: null, context: null }),
      togglePersist: () => set((state) => ({ persist: !state.persist })),
      setIsRefreshing: (isRefreshing) => set({ isRefreshing }),

      refresh: () => set({ isAuthenticated: false, token: null, context: null, isRefreshing: true }),
    }),
    { name: 'auth-store', partialize: (state) => ({ persist: state.persist }) },
  ),
);
